import React from "react";

import Toolbar from "@mui/material/Toolbar";

import { Theme } from "../../../Style/Theme";
import { TopTaskBar } from "../../atoms/TopTaskBar/TopTaskBar";

//TODO: need to move to templates
const TopNavigationBar = ({
  open,
  drawerWidth,
  children,
  backgroundColor,
  justifyContent,
  minHeight,
}) => {
  return (
    <div
      style={{
        zIndex: 1,
      }}
    >
      <TopTaskBar position="absolute" open={open} drawerWidth={drawerWidth}>
        <Toolbar
          sx={{ justifyContent: justifyContent ? justifyContent : "" }}
          style={{
            pr: "28px", // keep right padding when drawer closed
            backgroundColor: backgroundColor
              ? backgroundColor
              : Theme.palette.background.offWhite,
            minHeight: minHeight ? minHeight : "56px",
            borderBottom: "1px solid #E5E5EA",
            boxShadow: "0px transaparent",
          }}
        >
          {children}
        </Toolbar>
      </TopTaskBar>
    </div>
  );
};

export default TopNavigationBar;
